import React, {Component} from 'react'
import HomeElementCreateDialog from './HomeElementCreateDialog';
import {DialogContent, DialogTitle, IconButton, MenuItem, Select, Tooltip, Typography} from '@material-ui/core';
import {Add, ArrowBack, Home} from '@material-ui/icons';
import HomeGridElement from './HomeGridElement';
import HomeCarouselElement from './HomeCarouselElement';
import HomeBanners from './HomeBanners';
import {request} from '../../api-client';
import {BigSpinner} from '../../components/Letflow/Loading';
import localization from '../../config/localization';
import browserHistory from '../../utils/browserHistory';
import {homePathGenerator, slugify} from "../../api-client/core/authentication/utils";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import HomeFeaturedElement from "./HomeFeaturedElement";
import HomeNavbarButtons from "./HomeNavbar";
import Dialog from "@material-ui/core/Dialog";
import TextField from "../../components/Letflow/Form/TextField";
import Button from "../../components/CustomButtons/Button";
import DialogActions from "@material-ui/core/DialogActions";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../components/Letflow/Snackbar/GlobalSnackbar";
import Visibility from "@material-ui/icons/Visibility";
import {Link} from "react-router-dom";


const homeElementViewFactories = {
  'banner': ({ homeElement, onUpdateSuccess, onUpdateFailed, sectionId, sections }) =>
   <HomeBanners
      {...homeElement}
      onUpdateSuccess={onUpdateSuccess}
      onUpdateFailed={onUpdateFailed}
      sectionId={sectionId}
    />,
  'grid': ({  homeElement, onUpdateSuccess, onUpdateFailed, permissions, contentCreatorTypes, availablePlaylists, sectionId, sections, index }) =>
    <Draggable key={homeElement.id.toString()} draggableId={homeElement.id.toString()} index={index} style={{width: "100%"}}>
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
          <HomeGridElement
            {...homeElement}
            permissions={permissions}
            contentCreatorTypes={contentCreatorTypes}
            onUpdateSuccess={onUpdateSuccess}
            onUpdateFailed={onUpdateFailed}
            availablePlaylists={availablePlaylists}
            sectionId={sectionId}
            sections={sections}
          />
        </div>
      )}
    </Draggable>,
  'carousel': ({ homeElement, onUpdateSuccess, onUpdateFailed, permissions, contentCreatorTypes, availablePlaylists, sectionId, sections, index }) =>
    <Draggable key={homeElement.id.toString()} draggableId={homeElement.id.toString()} index={index} >
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
          <HomeCarouselElement
            {...homeElement}
            permissions={permissions}
            contentCreatorTypes={contentCreatorTypes}
            onUpdateSuccess={onUpdateSuccess}
            onUpdateFailed={onUpdateFailed}
            availablePlaylists={availablePlaylists}
            sectionId={sectionId}
            sections={sections}
          />
        </div>
      )}
    </Draggable>,
  'featured': ({ homeElement, onUpdateSuccess, onUpdateFailed, permissions, contentCreatorTypes, availablePlaylists, sectionId, sections, index }) =>
    <Draggable key={homeElement.id.toString()} draggableId={homeElement.id.toString()} index={index} >
      {provided => (
        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
          <HomeFeaturedElement
            {...homeElement}
            permissions={permissions}
            contentCreatorTypes={contentCreatorTypes}
            onUpdateSuccess={onUpdateSuccess}
            onUpdateFailed={onUpdateFailed}
            availablePlaylists={availablePlaylists}
            sectionId={sectionId}
            sections={sections}
          />
        </div>
      )}
    </Draggable>,
}

const requestHomeElements = (section = "") => request.home.getMetadata(section, true, true)
  .then(homeElements => homeElements.map(homeElement => ({ ...homeElement, items: homeElement.items && homeElement.items.data })))

class HomeEditor extends Component {

  constructor(props) {
    super(props)
    this.state = {
      requestingHomeElements: true,
      homeElements: [],
      navbarElements: [],
      creatingNewHomeElement: false,
      orderOfCreation: -1,
      permissions: [],
      contentCreatorTypes: [],
      sections: [],
      section: {value: null, label: "", main: false},
      availablePlaylists:  [],
      addSectionDialog: false,
      newSectionName: ""
    }
  }

  componentDidMount = () => {
    this.requestHomeElements()
  }

  requestContentCreatorTypes = (column, filter) =>
    request.contentCreatorType.getAll({
      filterBy: [{column: column, filter: filter}, {
        column: "include_all",
        filter: true
      }]
    })
      .then(contentCreatorTypes => this.setState({
        contentCreatorTypes: contentCreatorTypes.map(contentCreatorType => ({
            value: contentCreatorType.slug,
            label: contentCreatorType.name,
            allowVideo: contentCreatorType.allow_video,
            allowAudio: contentCreatorType.allow_audio,
            id: contentCreatorType.id,
            isTalent: contentCreatorType.type === 'talent'
          })
        )
      }))

  requestHomeElements = () =>
    this.setState({requestingHomeElements: true}, () =>
      this.requestSections()
        .then(() => requestHomeElements(this.state.section.value)
          .then(homeElements => this.setState({
            navbarElements: homeElements.filter(e => e.type === 'navbar'),
            homeElements: homeElements.filter(e => e.type !== 'navbar'),
          }))
          .then(() => this.requestContentCreatorTypes())
          .then(() => this.requestPlaylists())
          .then(() => this.setState({requestingHomeElements: false}))
          .catch(() => browserHistory.goBack())
        )
    )

  requestSections = () =>
    request.section.getAll()
      .then(response => this.setState({
        section: {value: response[0].id, label: response[0].name, main: response[0].main},
        sections: response.map(section => ({value: section.id, label: section.name, main: section.main}))
      }))

  addNewSection = () => request.section.create({name: this.state.newSectionName})
    .then(()  => this.setState({ newSectionName: "", addSectionDialog: false },
      () => GlobalSnackbar.show({
        message: localization.get("section.added"),
        type: GlobalSnackbarTypes.SUCCESS
      })))
    .then(()  => this.requestSections())
    .catch(() => GlobalSnackbar.show({ message: localization.get("section.fail"), type: GlobalSnackbarTypes.ERROR }))

  addSectionDialog = () =>
    <Dialog open={this.state.addSectionDialog} onClose={() => this.setState({addSectionDialog: false, newSectionName: ""})}>
      <DialogTitle style={{ width: "100%" }} id="simple-dialog-title">{localization.get("section.add")}</DialogTitle>
      <DialogContent>
        <TextField
          value={this.state.newSectionName}
          onChange={e => this.setState({ newSectionName: e.target.value })}
          label={localization.get("section.name")}
          fullWidth />
      </DialogContent>
      <DialogActions>
        <Button onClick={this.addNewSection} color='default' style={{ backgroundColor: "black" }} disabled={this.state.submitting}>
          {localization.get("send")}
        </Button>
      </DialogActions>
    </Dialog>


  requestPlaylists = () =>
    request.playlist.getAll({filterBy: [{column: 'type', filter: "global"}]})
      .then(playlists => this.setState({availablePlaylists: playlists.map(p => ({value: p.id, label: p.title}))}))

  setElements = elements => this.setState({homeElements: elements})

  render = () => {
    return (
      <div>
        {this.addSectionDialog()}
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <p style={{padding: "8px 15px"}}>{localization.get('section.select')}</p>
          <Select
            style={{width: "30%", marginBottom: 15}}
            onChange={e => {
              this.setState({section: this.state.sections.find(section => section.value === e.target.value)})
              requestHomeElements(e.target.value)
                .then(homeElements => {
                  return this.setState({
                    navbarElements: homeElements.filter(e => e.type === 'navbar'),
                    homeElements: homeElements.filter(e => e.type !== 'navbar'),
                  })
                })
            }}
            value={this.state.section.value}
          >
            {this.state.sections.map(section => <MenuItem value={section.value}>{section.label}</MenuItem>)}
          </Select>
          {/*<Typography variant='display1'>{this.state.section.label}</Typography>*/}
          <Link
            to={this.state.section.main ?
              homePathGenerator('') :
              `/home/${this.state.section.value}-${slugify(this.state.section.label).replace('-', '')}`}
            target="_blank">
            <IconButton
              style={{float: 'right', bottom:5}}
            >
              <Tooltip title={localization.get('section.visit')}>
                <Visibility/>
              </Tooltip>
            </IconButton>
          </Link>
        </div>
        {!this.state.requestingHomeElements &&
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {this.makeSelectElementTypeDialog()}
          {!this.state.requestingHomeElements &&
          <IconButton style={{margin: '10px 0 10px 0'}}
                      onClick={() => this.setState({
                        creatingNewHomeElement: true,
                        orderOfCreation: 1
                      })}><Add/></IconButton>
          }
          {this.state.homeElements.length === 0 && !this.state.requestingHomeElements &&
          <Typography>{localization.get('home_editor.add_a_new_element')}</Typography>}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: 10,
              overflow: "auto",
              width: "100%",
              alignItems: "center",
            }}
          >
          <HomeNavbarButtons
            navbarElements={this.state.navbarElements}
            contentCreatorTypes={this.state.contentCreatorTypes}
            onUpdateSuccess={() => this.requestHomeElements()}
            onUpdateFailed={() => console.log('failed')}
            sectionId={this.state.section.value}
            sections={this.state.sections}
          />
          </div>
          <DragDropContext
            onDragEnd={result => {
              if (result.destination) {
                const destination = result.destination.index;
                const source = result.source.index;

                if (destination !== source) {
                  const currentElements = this.state.homeElements;
                  const element = this.state.homeElements[source]
                  const direction = destination < source ? -1 : 1;
                  const involved = direction === -1 ? currentElements.slice(destination, source) : currentElements.slice(source + 1, destination + 1);

                  this.setState({homeElements: currentElements.sort((a, b) => a.order - b.order)})
                  currentElements[source].order = currentElements[destination].order;
                  involved.forEach(x => (x.order -= direction));

                  const orderData = this.state.homeElements.sort((a, b) => a.order - b.order)
                    .map((element, index) => {
                      return ({id: element.id, order: index})
                    })

                  request.home.updateOrder(orderData)
                }
              }
            }}
          >
            <Droppable
              droppableId="home-elements"
              direction="vertical"
            >
              {provided => (
                <div
                  ref={provided.innerRef}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: 10,
                    overflow: "auto",
                    width: "100%",
                    alignItems: "center",
                  }}
                  {...provided.droppableProps}
                >
                  {this.makeHomeElements()}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        }
        <IconButton
          onClick={() => this.props.history.push(this.state.channelEditor ? '/channels' : '/clients')}><ArrowBack/></IconButton>
      </div>
    )
  }

  makeSelectElementTypeDialog = () => this.state.creatingNewHomeElement &&
    <HomeElementCreateDialog
      order={this.state.orderOfCreation}
      currentElementTypes={this.state.homeElements.map(he => he.type)}
      permissions={this.state.permissions}
      contentCreatorTypes={this.state.contentCreatorTypes}
      availablePlaylists={this.state.availablePlaylists}
      sectionId={this.state.section.value}
      sections={this.state.sections}
      onClose={state => {
        this.setState({creatingNewHomeElement: false})
        if (state === 'success') {
          this.requestHomeElements()
        }
      }}
    />

  makeHomeElements = () =>
    this.state.requestingHomeElements ? <BigSpinner/> : this.state.homeElements.map(element => {
      if (element.type === "banner") {
        element.order = 0;
      }
      return element
    }).sort((a, b) => a.order - b.order).map(this.makeHomeElementView)

  makeHomeElementView = (homeElement, index) =>
    this.appendAddButtonToHomeElementView(homeElementViewFactories[homeElement.type]({
      homeElement,
      onUpdateSuccess: this.requestHomeElements,
      onUpdateFailed: () => console.log('failed'),
      permissions: this.state.permissions,
      contentCreatorTypes: this.state.contentCreatorTypes,
      availablePlaylists: this.state.availablePlaylists,
      sectionId: this.state.section.value,
      sections: this.state.sections,
      index: index
    }), () => this.setState({creatingNewHomeElement: true, orderOfCreation: homeElement.order + 1}))

  appendAddButtonToHomeElementView = (homeElementView, onClick) =>
    <div style={{width: '100%', maxWidth: '1000px', position: 'relative', float: 'left'}}>
      {homeElementView}
      <IconButton style={{margin: '10px 0 10px 0', marginLeft: "calc(50% - 24px)"}}
                  onClick={onClick}><Add/></IconButton>
    </div>
}

export default HomeEditor
